import { useCallback } from 'react'
import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Typography } from '@/components/ui/typography'
import { Trash2 } from 'lucide-react'

interface BooleanFilterEditorProps {
  value: boolean | undefined
  onValueChange: (value: boolean) => void
  onRemove?: () => void
  label?: string
}

export function BooleanFilterEditor({
  value,
  onValueChange,
  onRemove,
  label,
}: BooleanFilterEditorProps) {
  const handleSelect = useCallback(
    (newValue: boolean) => {
      onValueChange(newValue)
    },
    [onValueChange]
  )

  return (
    <div className="flex flex-col gap-1 p-3">
      <div className="flex items-center justify-between mb-2">
        {label && (
          <span className="font-univers text-sm text-primary">[{label}]</span>
        )}
        {onRemove && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onRemove}
            className="h-8 w-8 ml-auto"
          >
            <Trash2 className="h-4 w-4 text-destructive/50" />
          </Button>
        )}
      </div>
      <button
        type="button"
        onClick={() => handleSelect(true)}
        className="flex items-center gap-2 px-2 py-1.5 rounded-sm hover:bg-primary/8 cursor-pointer"
      >
        <Checkbox
          checked={value === true}
          className="rounded-xs border-1 border-muted-foreground data-[state=checked]:[&>[data-slot=checkbox-indicator]>svg]:text-white"
        />
        <Typography variant="body-sm" className="font-normal">
          True
        </Typography>
      </button>
      <button
        type="button"
        onClick={() => handleSelect(false)}
        className="flex items-center gap-2 px-2 py-1.5 rounded-sm hover:bg-primary/8 cursor-pointer"
      >
        <Checkbox
          checked={value === false}
          className="rounded-xs border-1 border-muted-foreground data-[state=checked]:[&>[data-slot=checkbox-indicator]>svg]:text-white"
        />
        <Typography variant="body-sm" className="font-normal">
          False
        </Typography>
      </button>
    </div>
  )
}
